// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <detail-view
  disableModify
  :endpoint="endpoint + 'apikeys'"
  name="API Key"
  parentRoute="apikeys"
  permissions="apikeys"
  :values="values"
  ></detail-view>
</template>
<script>
import {ENDPOINT} from '@/shared/constants'
import DetailView from 'vue-common/components/DetailView.vue'

export default {
  components: {
    DetailView
  },

  data () {
    return {
      endpoint: ENDPOINT,
      values: [
        {
          name: 'Basic',
          items: [
            [
              {
                name: 'Name',
                value: 'name',
                required: true
              },
              {
                name: 'Token',
                value: 'token',
                disabled: true
              },
              {
                name: 'Roles',
                value: 'roles',
                context: ENDPOINT + 'roles',
                type: 'select',
                itemText: 'name',
                itemValue: 'id',
                multiple: true,
                required: true
              }
            ]
          ]
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// ApiKeyEdit.vue?636d6dd5